import React, { useState } from "react";
import { Title, Meta, Link as HeadLink } from "react-head";
import { motion } from "motion/react";

import WallpaperCatBar from "../components/Client/WallpaperCatBar";
import WallpaperGrid from "../components/Client/WallpaperGrid";
import ClientAdSense from "../components/Client/ClientAdSense";
import FixedButton from "../components/Client/FixedButton";
import WallpaperFooter from "../components/Client/WallpaperFooter";

const ClientWallpaper = () => {
    const [total, setTotal] = useState(0);

    return (
        <div className='min-h-screen dm-sans client-home-bg'>
            <Title>Wallpapers | PicPromptify</Title>
            <Meta
                name='description'
                content='Browse and download free HD phone wallpapers on PicPromptify — nature, abstract, anime, cars and more.'
            />
            <Meta property='og:title' content='Wallpapers | PicPromptify' />
            <Meta property='og:type' content='website' />
            <HeadLink rel='canonical' href='https://picpromptify.com/wallpaper' />

            {/* top scrollable category bar (no navbar) */}
            <WallpaperCatBar activeSlug='' />
            <FixedButton />

            <section className='relative w-full px-4 sm:px-6 md:px-8 pt-5 md:pt-7 pb-12 md:pb-20'>
                <div className='mx-auto max-w-7xl'>
                    {/* top banner ad */}
                    <ClientAdSense
                        slot='9729451986'
                        containerClassName='w-full mb-5 md:mb-7'
                    />

                    <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        className='flex items-center justify-between gap-3 mb-5 md:mb-7'
                    >
                        <div className='flex items-center gap-2'>
                            <div
                                className='w-1 h-6 rounded-full'
                                style={{
                                    background:
                                        "linear-gradient(180deg, #7F00FF, #FCFA02)",
                                }}
                            />
                            <h1 className='text-client-font font-semibold text-sm md:text-lg tracking-wide uppercase'>
                                All Wallpapers
                            </h1>
                        </div>
                        {total > 0 && (
                            <div className='ios-glass px-3 py-1 rounded-full text-client-font/75 text-[10px] md:text-xs flex-shrink-0'>
                                <span className='tabular-nums font-bold text-client-title'>
                                    {total}
                                </span>{" "}
                                wallpapers
                            </div>
                        )}
                    </motion.div>

                    <WallpaperGrid
                        slug=''
                        onMeta={(r) => setTotal(r?.totalRecords || 0)}
                    />
                </div>
            </section>

            <WallpaperFooter />
        </div>
    );
};

export default ClientWallpaper;
